module.exports = __webpack_public_path__ + "img/empty-data.57ee1b09.svg";